<template>
  <div>
    <p v-if="chatRoom === null">
      {{ $t('loading') }}...
    </p>
    <div class="small_chat" v-else-if="chatRoom">
      <b>{{ chatRoom.participants.find(p => p.id_tyrion != client.id).name }}</b>

      <p v-if="messages.length === 0">
        {{ $t('for-now-wasnt-added-any-message') }}
      </p>
      <ul v-else class="mt-3">
        <li class="owner bg-none" v-if="socketIoReconnecting">
          <div class="group">
            <p class="text-info">
              {{ $t('reconnecting') }}
            </p>
          </div>
        </li>
        <li class="owner bg-none" v-if="typeof lastError === 'string' && lastError.length > 0">
          <div class="group">
            <p class="text-danger">
              {{ lastError }}
            </p>
          </div>
        </li>
        <li class="target typing" v-if="targetTyping">
          <div class="group">
            <div class="typing">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </li>
        <li v-for="(group, key) in groupedMessages" :class="group[0].id_user === client.id ? ' owner ' : ' target '">

          <div class="group" :class="`group-${key}`">
            <template v-for="message in group">
              <div class="dateTimeSeparator" v-if="isAlreadyAddedDate(message.mid) === false">
                <p class="separator_caption">
                  {{ formatTime(message.created_at, 'MMM. DD YYYY') }}
                </p>
              </div>
              <p class="message"
                 :data-name="message.id_user === client.id ? $t('you') : message.user.name"
                 :data-date="formatTime(message.created_at, 'DD.MM.YYYY HH:mm')"
                 :class="group[0].id_user === client.id ? ' owner ' : ' target '" @click="openedMessage = message.mid">
                {{ message.text }}
                <br>
              </p>
              <span class="message_addition" v-if="openedMessage === message.mid">
                <small v-if="message.id_user === client.id">{{ $t('you') }}</small>
                <small v-else>{{ message.user.name }}</small>
                <small>{{ formatTime(message.created_at, 'HH:mm:ss') }}</small>
              </span>
            </template>
          </div>
        </li>
        <li class="text-center" v-if="messages.length > 19 && messages.length != previousMessageCount">
          <div class="group">
            <button class="btn btn-outline-first btn-sm mt-3 mt-lg-5 btn-rounded d-flex align-items-center justify-content-center mx-auto" @click="loadMessages"
                    type="button">
              <TyIcon icon="ty-history-watch" width="1rem" class="me-1"/>
              <span class="d-inline-block">{{ $t('load-older-messages') }}</span>
            </button>
          </div>
        </li>
      </ul>

      <form @submit.prevent="sendMessage" class="chat-room-submit-section">
        <div class="mb-0 d-flex justify-content-around align-content-end">
            <textarea type="text" class="form-control" :class="{'overflow-hidden': !messageInput || (messageInput.scrollHeight < 180 && message.length < 200)}"
                      :placeholder="$t('message')" :aria-label="$t('message')" ref="messageInput"
                      rows="1" v-model="message" :disabled="sending || socketIoReconnecting" @keyup="toggleTyping" @keypress="toggleTyping"
                      @input="updateHeight"></textarea>
          <button name="message-submit-button" class="btn btn-first btn-rounded ms-3" type="submit"
                  :disabled="sending || socketIoReconnecting || message.length < 1">
            <TyIcon width="1.5rem" icon="ty-send" color="white"/>
          </button>
        </div>
      </form>

    </div>
  </div>
</template>

<script setup lang="ts">
import ChatRoom from "../../../../lib/models/SocketIo/ChatRoom";
import {PropType, ref} from "vue";
import Client from "../../../../lib/models/Client";
import BaseChat from "./base_chat";
import {formatTime} from "~/lib/functions";
import "@/assets/less/_messenger_small_chat.min.css";
import {obtainActiveLocale} from "../../../../composables/master_page";

const props = defineProps({
  room: Object as PropType<ChatRoom>,
  client: Object as PropType<Client>,
});

const emit = defineEmits(['onBackClick', 'onParticipantsIconClick']);
const activeLocale = obtainActiveLocale();

const openedMessage = ref(-1);

const {
  groupedMessages,
  submitMessage,
  message,
  sending,
  socketIoReconnecting,
  messages,
  lastError,
  targetTyping,
  loading,
  chatRoom,
  previousMessageCount,
  toggleTyping,
  loadMessages,
  messageInput,
  updateHeight
} = BaseChat(props);

const idsToSeparator = () => {
  const alreadyAddedDates = [];
  groupedMessages.value.forEach((groupMessages) => {
    groupMessages.forEach(message => {
      const date = formatTime(message.created_at, 'YYYY-MM-DD');
      if (alreadyAddedDates.some(f => f === date) === false) {
        alreadyAddedDates.push(date)
        alreadyAddedDates.push(message.mid)
      }
    })
  })
  return alreadyAddedDates;
};

const isAlreadyAddedDate = (id) => {
  return idsToSeparator().indexOf(id) <= -1;
};

const toggleLeftMenu = () => {
  emit('onBackClick');
};

const showParticipantsInfo = () => {
  emit('onParticipantsIconClick')
};


const sendMessage = () => {
  submitMessage(0);
}

</script>
